import { Box } from "@material-ui/core"
import { BlessingResponse } from "api"
import { useIsDesktop } from "common/MediaQueries"
import Image from "next/image"
import { useRouter } from "next/router"
import styled from "styled-components"

const StyledBox = styled(Box)`
  svg {
    position: absolute;
    top: 66px;
    right: 16px;
    z-index: 1;
    cursor: pointer;
    circle {
      fill: white;
    }
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;

    flex-direction: column;
    order: 1;
  }
`

const StyledWrapper = styled.div<{ $isaiimage?: boolean }>`
  display: flex;
  justify-content: flex-end;
  width: ${(p) => (p.$isaiimage ? "400px" : "450px")};
  img {
    border-radius: 5px;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
    height: ${(p) => (p.$isaiimage ? "440px" : "260px")};
    position: relative;
    margin-right: 0px;
    img {
      border-radius: 0px;
    }
  }
`

type GiftCardInfoProps = {
  giftCard: BlessingResponse
}

const GiftCardInfo = ({ giftCard }: GiftCardInfoProps) => {
  const isDesktop = useIsDesktop()
  const router = useRouter()
  const isAiImage =
    typeof window !== "undefined" &&
    giftCard?.isAiImage &&
    localStorage?.getItem("imageAiUrl") &&
    giftCard?.slug === JSON.parse(localStorage.getItem("slugAi"))
  const imageUrl = isAiImage
    ? JSON.parse(localStorage.getItem("imageAiUrl"))
    : giftCard?.image?.imageUrl
  const imageAlt = isAiImage ? "" : giftCard?.image?.imageUrl
  return (
    <StyledBox onClick={() => (isDesktop ? {} : router.back())}>
      <StyledWrapper $isaiimage={isAiImage}>
        <Image
          src={imageUrl}
          alt={imageAlt}
          layout={!isDesktop ? "fill" : "fixed"}
          width={isAiImage ? isDesktop && "400px" : isDesktop && "435px"}
          height={isAiImage ? isDesktop && "440px" : isDesktop && "285px"}
        />
      </StyledWrapper>
    </StyledBox>
  )
}

export default GiftCardInfo
